/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
==========================================================================================*/


export default [
  {
    url: '/dashboard',
    name: 'Dashboard',
    // tag: '2',
    // tagColor: 'warning',
    icon: 'HomeIcon',
    i18n: 'Dashboard'
  },
  {
    header: 'Menyu',
    icon: 'PackageIcon',
    i18n: 'Apps',
    items: [
      {
        url: '/municipalities',
        name: 'municipalities',
        slug: 'municipalities',
        icon: 'ClipboardIcon',
        i18n: 'Municipalities'
      },
      {
        url: '/terminals',
        name: 'terminals',
        slug: 'terminals',
        icon: 'TerminalIcon',
        i18n: 'Terminals'
      },
      {
        url: '/statistics',
        name: 'statistics',
        icon: 'FilterIcon',
        i18n: 'Statistics',
        submenu: [
          {
            url: '/group-payment-statistics',
            name: 'groupPaymentStatistics',
            slug: 'group-payment-statistics',
            i18n: 'groupPaymentStatistics'
          },
          {
            url: '/details-payment-statistics',
            name: 'detailsPaymentStatistics',
            slug: 'details-payment-statistics',
            i18n: 'detailsPaymentStatistics'
          },
          {
            url: '/terminal-payment',
            name: 'terminal-payment',
            slug: 'terminal-payment',
            icon: 'LayersIcon',
            i18n: 'Payments'
          }
        ]
      },
      {
        url: '/pay',
        name: 'payments',
        slug: 'payments',
        icon: 'CreditCardIcon',
        i18n: 'Pay'
      },
      {
        url: '/invoice',
        name: 'invoice',
        slug: 'invoice',
        icon: 'PrinterIcon',
        i18n: 'DuplicateInvoice'
      }

    ]
  }
]

